const indexComponent = require('./components/Login');

const indexRoute = {
  component: indexComponent,
};

module.exports = {
  path: 'login',
  getIndexRoute(partialNextState, cb) {
    require.ensure([], () => {
      cb(null, indexRoute);
    });
  },
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/LoginManager'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/login/index.js